import * as semver from 'semver'

export const contractSupportsComments = ({
  contractVersion,
  contractStandard,
  salesType = 'Public',
}: {
  contractVersion?: string | null
  contractStandard?: 'ERC721' | 'ERC1155'
  salesType?: 'Public' | 'Presale'
}) => {
  if (!contractStandard || !contractVersion) {
    return false
  }

  // Try force-convert version format to semver format
  const semVerContractVersion = semver.coerce(contractVersion)?.raw
  if (!semVerContractVersion) return false

  if (contractStandard === 'ERC1155') {
    // 1155 allowlist minting doesn't support comments currently
    if (salesType === 'Presale') {
      return false
    }

    // For ERC1155s, this is the fixedPriceContract version, NOT the main contract version
    return semver.gte(semVerContractVersion, '1.1.0')
  } else {
    return semver.gte(semVerContractVersion, '12.0.0')
  }
}
